import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { StyledSvg } from '../styled.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function EmptyArtwork(props) {
  return /*#__PURE__*/jsxs(StyledSvg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 247 203"
  }, props, {
    children: [/*#__PURE__*/jsxs("g", {
      opacity: 0.5,
      children: [/*#__PURE__*/jsxs("g", {
        opacity: 0.5,
        children: [/*#__PURE__*/jsx("g", {
          filter: "url(#a)",
          children: /*#__PURE__*/jsx("ellipse", {
            rx: 41.121,
            ry: 30.625,
            transform: "matrix(.98798 .1546 -.41703 .9089 98.186 78.751)",
            fill: "#FFB673"
          })
        }), /*#__PURE__*/jsx("g", {
          filter: "url(#b)",
          children: /*#__PURE__*/jsx("ellipse", {
            rx: 22.636,
            ry: 16.858,
            transform: "matrix(.98798 .1546 -.41703 .9089 172.623 68.886)",
            fill: "#85C1F5"
          })
        }), /*#__PURE__*/jsx("g", {
          filter: "url(#c)",
          children: /*#__PURE__*/jsx("ellipse", {
            rx: 29.049,
            ry: 21.634,
            transform: "matrix(.98798 .1546 -.41703 .9089 164.774 101.52)",
            fill: "#6966F2"
          })
        })]
      }), /*#__PURE__*/jsxs("g", {
        opacity: 0.5,
        children: [/*#__PURE__*/jsx("g", {
          filter: "url(#d)",
          children: /*#__PURE__*/jsx("ellipse", {
            rx: 26.104,
            ry: 48.243,
            transform: "matrix(.41703 .9089 -.98798 .1546 99.287 89.91)",
            fill: "#FFB673"
          })
        }), /*#__PURE__*/jsx("g", {
          filter: "url(#e)",
          children: /*#__PURE__*/jsx("ellipse", {
            rx: 14.369,
            ry: 26.556,
            transform: "matrix(.41703 .9089 -.98798 .1546 151.135 122.623)",
            fill: "#85C1F5"
          })
        }), /*#__PURE__*/jsx("g", {
          filter: "url(#f)",
          children: /*#__PURE__*/jsx("ellipse", {
            rx: 18.44,
            ry: 34.08,
            transform: "matrix(.41703 .9089 -.98798 .1546 98.815 134.971)",
            fill: "#6966F2"
          })
        })]
      })]
    }), /*#__PURE__*/jsx("g", {
      filter: "url(#g)",
      children: /*#__PURE__*/jsx("rect", {
        x: 27,
        y: 55,
        width: 180,
        height: 38,
        rx: 6,
        fill: "#fff"
      })
    }), /*#__PURE__*/jsx("rect", {
      x: 63,
      y: 69,
      width: 114,
      height: 10,
      rx: 2,
      fill: "#F2F2F7"
    }), /*#__PURE__*/jsx("rect", {
      x: 35,
      y: 64,
      width: 20,
      height: 20,
      rx: 4,
      fill: "#52B9CC"
    }), /*#__PURE__*/jsx("path", {
      d: "M49 72.25v4.5a.75.75 0 0 1-.75.75h-6.5a.75.75 0 0 1-.75-.75v-5.5a.75.75 0 0 1 .75-.75h2.5l1 1h3a.75.75 0 0 1 .75.75Z",
      fill: "#fff",
      opacity: 0.9
    }), /*#__PURE__*/jsx("g", {
      filter: "url(#h)",
      children: /*#__PURE__*/jsx("rect", {
        x: 37,
        y: 101,
        width: 180,
        height: 38,
        rx: 6,
        fill: "#fff"
      })
    }), /*#__PURE__*/jsx("rect", {
      x: 73,
      y: 115,
      width: 118,
      height: 10,
      rx: 2,
      fill: "#F2F2F7"
    }), /*#__PURE__*/jsx("rect", {
      x: 45,
      y: 110,
      width: 20,
      height: 20,
      rx: 4,
      fill: "#6966F2"
    }), /*#__PURE__*/jsx("path", {
      d: "M56 116v2h2l-2-2Zm-.5 2v-2h-2.75a.75.75 0 0 0-.75.75v6.5c0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75v-4.75h-1.986a.502.502 0 0 1-.514-.5Z",
      fill: "#fff",
      opacity: 0.9
    }), /*#__PURE__*/jsxs("defs", {
      children: [/*#__PURE__*/jsxs("filter", {
        id: "a",
        x: 5.587,
        y: 0.194,
        width: 185.197,
        height: 157.115,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/jsx("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/jsx("feBlend", {
          "in": "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/jsx("feGaussianBlur", {
          stdDeviation: 25,
          result: "effect1_foregroundBlur_108_4"
        })]
      }), /*#__PURE__*/jsxs("filter", {
        id: "b",
        x: 99.174,
        y: 3.166,
        width: 146.897,
        height: 131.439,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/jsx("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/jsx("feBlend", {
          "in": "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/jsx("feGaussianBlur", {
          stdDeviation: 25,
          result: "effect1_foregroundBlur_108_4"
        })]
      }), /*#__PURE__*/jsxs("filter", {
        id: "c",
        x: 84.681,
        y: 31.347,
        width: 160.185,
        height: 140.347,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/jsx("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/jsx("feBlend", {
          "in": "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/jsx("feGaussianBlur", {
          stdDeviation: 25,
          result: "effect1_foregroundBlur_108_4"
        })]
      }), /*#__PURE__*/jsxs("filter", {
        id: "d",
        x: 0.386,
        y: 15.033,
        width: 197.802,
        height: 149.754,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/jsx("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/jsx("feBlend", {
          "in": "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/jsx("feGaussianBlur", {
          stdDeviation: 25,
          result: "effect1_foregroundBlur_108_4"
        })]
      }), /*#__PURE__*/jsxs("filter", {
        id: "e",
        x: 74.217,
        y: 58.93,
        width: 153.836,
        height: 127.387,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/jsx("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/jsx("feBlend", {
          "in": "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/jsx("feGaussianBlur", {
          stdDeviation: 25,
          result: "effect1_foregroundBlur_108_4"
        })]
      }), /*#__PURE__*/jsxs("filter", {
        id: "f",
        x: 14.27,
        y: 67.397,
        width: 169.089,
        height: 135.147,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/jsx("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/jsx("feBlend", {
          "in": "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/jsx("feGaussianBlur", {
          stdDeviation: 25,
          result: "effect1_foregroundBlur_108_4"
        })]
      }), /*#__PURE__*/jsxs("filter", {
        id: "g",
        x: 19,
        y: 51,
        width: 196,
        height: 54,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/jsx("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/jsx("feColorMatrix", {
          "in": "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/jsx("feOffset", {
          dy: 4
        }), /*#__PURE__*/jsx("feGaussianBlur", {
          stdDeviation: 4
        }), /*#__PURE__*/jsx("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/jsx("feColorMatrix", {
          values: "0 0 0 0 0.372122 0 0 0 0 0.326944 0 0 0 0 0.445833 0 0 0 0.1 0"
        }), /*#__PURE__*/jsx("feBlend", {
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_108_4"
        }), /*#__PURE__*/jsx("feBlend", {
          "in": "SourceGraphic",
          in2: "effect1_dropShadow_108_4",
          result: "shape"
        })]
      }), /*#__PURE__*/jsxs("filter", {
        id: "h",
        x: 29,
        y: 97,
        width: 196,
        height: 54,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/jsx("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/jsx("feColorMatrix", {
          "in": "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/jsx("feOffset", {
          dy: 4
        }), /*#__PURE__*/jsx("feGaussianBlur", {
          stdDeviation: 4
        }), /*#__PURE__*/jsx("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/jsx("feColorMatrix", {
          values: "0 0 0 0 0.372122 0 0 0 0 0.326944 0 0 0 0 0.445833 0 0 0 0.1 0"
        }), /*#__PURE__*/jsx("feBlend", {
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_108_4"
        }), /*#__PURE__*/jsx("feBlend", {
          "in": "SourceGraphic",
          in2: "effect1_dropShadow_108_4",
          result: "shape"
        })]
      })]
    })]
  }));
}

export { EmptyArtwork };
